<div class="card" id="pedigree" [formGroup]="animalForm">
  <div class="card-header justify-content-start column-gap-4">
    Pedigree

    <a
      [routerLink]="'/arbore-genealogic/' + matricol"
      target="_blank"
      class="fs-5"
    >
      Vizualizează
    </a>

    <button
      *ngIf="!disabledFields['pedigree_download'] && !loadingDescarcaXLS"
      type="button"
      class="btn btn-sm btn-success"
      (click)="downloadXLSArboreGenealogic()"
    >
      Descarcă XLS
    </button>

    <span
      *ngIf="loadingDescarcaXLS"
      class="spinner-border text-info small avatar-xs ml-4"
      role="status"
    >
    </span>
  </div>

  <div class="card-body">
    <div class="zoom-sm-25 zoom-75 overflow-auto pb-4">
      <p-organizationChart
        [(value)]="animalFamilyTree"
        selectionMode="single"
        [preserveSpace]="false"
        styleClass="company"
        (onNodeSelect)="onNodeSelect($event)"
      >
        <ng-template let-node pTemplate="animal">
          <div>
            <div class="node-header ui-corner-top">
              <span>{{ node.numarmatricol }}</span><br>
              <span *ngIf="node.codtaur">( {{ node.codtaur }} )</span>
              <div><i>{{ node.nume }}</i></div>
              <div class="separator"></div>
              <div>{{ node.sex_text }}</div>
            </div>
            <div class="node-content">
              <div>{{ node.datanastere }}</div>
              <div class="text-muted">
                {{ node.sectiune_rg }}
              </div>
              <div>{{ node.rasa }}</div>
            </div>
          </div>
        </ng-template>
        <ng-template let-node pTemplate="parent">
          <div>
            <button
              *ngIf="
                (node.ascendenta === 'T' || node.ascendenta === 'M')
                && disabledFields['pedigree_if_delete_parent']"
                class="btn p-0"
              (click)="deleteParent(node)"
            >
              <i class="mdi mdi-close-circle delete-parent"></i>
            </button>
            <div class="node-header">
              <span>{{ node.numarmatricol }}</span><br>
              <span *ngIf="node.codtaur">( {{ node.codtaur }} )</span>
              <div><i>{{ node.nume }}</i></div>
              <div class="separator"></div>
              <div>{{ node.sex_text }}</div>
            </div>
            <div class="node-content">
              <div>{{ node.datanastere }}</div>
              <div
                *ngIf="node.sectiune_rg"
                class="text-muted"
              >
                {{ node.sectiune_rg }}
              </div>
              {{ node.ascendenta }},
              {{ node.rasa }}
            </div>
          </div>
        </ng-template>
      </p-organizationChart>
    </div>
  </div>
</div>


<app-add-update-animal
  [modalData]="addEditModalData"
  (notifyClose)="closeAddUpdateModal($event)"
>
</app-add-update-animal>
